import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { ChakraProvider } from "@chakra-ui/react";
import { SkipNavLink } from "@chakra-ui/skip-nav";
import { theme } from "theme/index";

import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { replaceIdiomaticTextsWithSvgs } from "utils/fontAwesomeUtils";

import jQuery from "jquery";

import ms from "ms";
import { initDatadogRum } from "utils/datadogUtils";
import Root from "./js/components/Root";

// normalize needs to come in first before ALL other styles
import "normalize.css";
import "./scss/main.scss";

// Makes jQuery available in the global scope.
// I don't think this is required anymore as the only two places I can see jQuery being used are in
// authorisedApi.js and ClassroomToolMenu/index.jsx and both of these are now using the import statement.
declare global {
	interface Window {
		$: typeof jQuery;
		jQuery: typeof jQuery;
	}
}
window.$ = window.jQuery = jQuery;

initDatadogRum();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			cacheTime: ms("5m"),
			retry: 3,
			structuralSharing: false,
		},
	},
});

replaceIdiomaticTextsWithSvgs();

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
	<ChakraProvider theme={theme}>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<SkipNavLink className="skip-link" tabIndex={0}>
					Skip navigation
				</SkipNavLink>
				<Root />
			</BrowserRouter>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	</ChakraProvider>
);
